<template>
     <main>
        <inncosys-breadcrumbs :history="pathHistory"></inncosys-breadcrumbs>
        <div class="row">
           <div class="col l4 offset-l4 input-field">
              <inncosys-date-picker  :options="{}" label="Fecha Consulta" v-model="fechaConsulta"></inncosys-date-picker>
            </div>

        </div>

        <div class="row">
            <div class="col s12 l12 card">
             <div class="row">
               <div class="col l12 s12">
                 <div v-if="loadingResults" class="progress">
                   <div class="indeterminate"></div>
                 </div>
                 <datatable title="Ocupación Financiera" :columns="columns" :rows="rows" ></datatable>
                </div>
              </div>
               <div class="row">
                <div class="col l12">
                  <div id="detalleOcupacionStacked"></div>
                </div>
              </div>
            </div>
        </div>

    </main>
</template>

<script>
import Breadcrumbs from '../../components/commun/Breadcrumbs.vue';
import DataTable from 'vue-materialize-datatable';
import DatePicker from '../../components/commun/forms/DatePicker.vue';
import * as Highcharts from 'highcharts';
import Select from '../../components/commun/forms/Select.vue';
import { db } from '../../main';

const moment = require('moment');

export default {
  mounted() {},
  components: {
    inncosysBreadcrumbs: Breadcrumbs,
    inncosysSelect: Select,
    datatable: DataTable,
    inncosysDatePicker: DatePicker,
  },
  data() {
    return {
      pathHistory: [
        { name: 'Inicio', route: '/' },
        {
          name: 'Reportes Directivos',
          route: '/reportes-directivos/ocupacion',
        },
        {
          name: 'Ocupación Financiera',
          route: '/reportes-directivos/ocupacion-financiera',
        },
      ],
      selectedStore: 'ALL',
      loadingResults: false,
      fechaConsulta: new Date(),
      columns: [
        {
          label: 'Familia', // Column name
          field: 'familia', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },

        {
          label: 'Marca', // Column name
          field: 'marca', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Modelo', // Column name
          field: 'modelo', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Seire', // Column name
          field: 'serie', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Fecha Alta', // Column name
          field: 'fechaAlta', // Field name from row
          numeric: true, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Costo', // Column name
          field: 'costo', // Field name from row
          numeric: true, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Ingreso Total', // Column name
          field: 'ingresoTotal', // Field name from row
          numeric: true, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Objetivo del Periodo', // Column name
          field: 'objetivoPeriodo', // Field name from row
          numeric: true, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Ocupacion Financiera', // Column name
          field: 'ocupacionFinanciera', // Field name from row
          numeric: true, // Affects sorting
          html: false, // Escapes output if false.
        },
      ],
      series: [],
      rows: [],
      rawData: [],
    };
  },
  methods: {
    getOcupacionFinanciera(fechaConsulta) {
      console.log(fechaConsulta, 'obtieniendo');
      this.loadingResults = true;
      this.rows = [];
      const vueInstance = this;
      db.ref('computed')
        .child('ocupacion-financiera')
        .child(fechaConsulta)
        .once('value')
        .then((ocupacionFinancieraEquiposSnapshot) => {
          ocupacionFinancieraEquiposSnapshot.forEach((ocupacionSnapshot) => {
            vueInstance.rawData.push(ocupacionSnapshot.val());
            vueInstance.rows.push({
              costo: `$${ocupacionSnapshot.val().costo.formatMoney(2)}`,
              dias: ocupacionSnapshot.val().dias,
              familia: ocupacionSnapshot.val().familia,
              fechaAlta: ocupacionSnapshot.val().fechaAlta,
              ingresoTotal:
                `$${ocupacionSnapshot.val().ingresoTotal.formatMoney(2)}`,
              marca: ocupacionSnapshot.val().marca,
              metaLograda:
                `${parseFloat((ocupacionSnapshot.val().metaLograda * 100).toFixed(2))}%`,
              modelo: ocupacionSnapshot.val().modelo,
              objetivoPeriodo:
                `${parseFloat((ocupacionSnapshot.val().objetivoPeriodo * 100).toFixed(2))}%`,
              ocupacionFinanciera:
                `${parseFloat((ocupacionSnapshot.val().ocupacionFinanciera * 100).toFixed(2))}%`,
              serie: ocupacionSnapshot.val().serie,
            });
          });
          vueInstance.loadingResults = false;
          vueInstance.plotChart();
        });
    },
    plotChart() {
      const series = [
        {
          name: '% Objetivo/Meta alcanzado',
          data: [],
        },
      ];
      this.loadingResults = false;
      const datosFamilia = {};
      this.rawData.forEach((equipo) => {
        if (!datosFamilia[equipo.familia]) {
          datosFamilia[equipo.familia] = {
            equipos: [],
            sumMetas: 0,
            countEquipos: 0,
            metaPromedio: 0,
          };
        }
        datosFamilia[equipo.familia].equipos.push(equipo);
        datosFamilia[equipo.familia].sumMetas += equipo.metaLograda;
        datosFamilia[equipo.familia].countEquipos++;
        datosFamilia[equipo.familia].metaPromedio = parseFloat((
          datosFamilia[equipo.familia].sumMetas /
          datosFamilia[equipo.familia].countEquipos).toFixed(2));
      });
      const familias = Object.keys(datosFamilia);
      familias.forEach((familia) => {
        series[0].data.push({
          name: familia,
          y: datosFamilia[familia].metaPromedio,
          equipos: datosFamilia[familia].equipos,
        });
      });
      console.log(series);
      Highcharts.chart('detalleOcupacionStacked', {
        chart: {
          type: 'bar',
          height: series[0].data.length * 45 + 120,
        },
        title: {
          text: 'Ocupación financiera',
        },
        xAxis: {
          categories: familias,
        },
        series,
        yAxis: {
          min: 0,
          title: {
            text: 'Ocupación',
          },
        },

        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat:
            '{series.name}: {point.z}<br/>Total: {point.totalEquipos}',
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            },
          },
        },
      });
      console.log(Highcharts);
    },
  },
  watch: {
    fechaConsulta(value) {
      this.getOcupacionFinanciera(moment(value).format('YYYY-MM-DD'));
    },
  },
};
</script>
<style>
</style>
